import useOffClick from '@flight-workspace/common-client/src/hooks/useOffClick';
import classNames from 'classnames/bind';
import { useState } from 'react';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  areaCode: string;
  period: number;
}

export default function Tooltip({ areaCode, period }: IProps) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useOffClick(() => setIsOpen(false), { stopPropagation: true });

  return (
    <>
      <button
        className={cx('info')}
        type="button"
        aria-label="그래프 안내"
        data-event-nlog="click"
        data-event-area-code={`${areaCode}.pricegraphinfo`}
        onClick={() => setIsOpen(prev => !prev)}
      />
      {isOpen && (
        <div className={cx('tooltip')} ref={ref} role="tooltip">
          <p className={cx('text')}>
            {period}일 동안 네이버에서 확인한 데이터를 기반으로, 검색하신
            출발지와 목적지, 일정, 좌석 등급이 동일한 항공권의 최저가 변동
            내역을 알려드립니다. 데이터가 충분하지 않을 경우 미노출될 수
            있습니다.
          </p>
          <button
            className={cx('close')}
            type="button"
            aria-label="툴팁 닫기"
            onClick={() => setIsOpen(false)}
          />
        </div>
      )}
    </>
  );
}
